import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() => import("@lexus.com/ui/dist/modules/FCVPromo"));

const PromoEditConfig = {
  emptyLabel: "Promo",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  return {
    component: "FCVPromo",
    props: {
      heading: props.categoryHeadline,
      color: props.color,
      tiles: (props.promoItems || []).map((item) => ({
        heading: item.subTag,
        year: item.tag,
        href: item.href,
        color: item.color,
        image: {
          desktop: {
            id: "",
            type: "desktop",
            src: item.image,
            alt: "Desktop Image",
            width: "",
            height: "",
            disclaimer: {
              position: item.disclaimerPosition,
              color: item.disclaimerColor,
              text: item.disclaimer,
            },
          },
        },
      })),
    },
  };
};

const Promo = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/promo")(
  Promo,
  PromoEditConfig
);
